import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Card, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import CLabel from '../../../../components/Common/CLabel';
import { useGetContractSubPartie, useGetPolynomyFormConfig, useGetSubPartieFormConfig } from '../../../../hooks/component/sPay/useOfContractParties';
import { useDispatch, useSelector } from 'react-redux';
import { action_addContractSubPartieSubItem, action_addPartiePolinomy, action_addSubPartiePolinomy, action_updateContractPartieList, action_updateContractPartieSelected, action_updateContractPartieSelectedId, action_updateContractPartieSidePanelIsOpen, action_updateContractSubPartieItem, action_updateFormConfigSubPartie } from '../../../../reducers/actions/PAY/actions';
import { __MessageTypes, enum__ENUM_CLASE_PARTIDA, enum_CONTACTPARTIE_POLINOMY_FORM_VIEW, enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW, enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG, enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE } from '../../../../common/Dictionaries';
import TablePolynomyItem from '../../../../components/Products/sAdjustment/Polynomy/TablePolynomyItem';
import JqxNumberInput from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxnumberinput';
import JqxInput from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxinput';
import { Dropdown, Icon } from '@fluentui/react';
import CValidator from '../../../../components/Common/CValidator';
import DatePicker from 'react-datepicker';
import { isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty, isNullUndefinedOrEmptyOrZero, showMessage } from '../../../../common/Helpers';
import { isSameNumberInputValue } from '../../../../common/jqxNumberInput';
import { __OBJECT_STRUCTURE_ContractSubPartie, __OBJECT_STRUCTURE_GetPolynomy } from '../../../../common/ObjectStructures/sKPI';
import { __calculateTotalRestAdjustmentAmount, __onRenderMonthContent, CalendarCustomInput } from '../../../../common/CommonFuctions';
import PropTypes from 'prop-types';
import { isPonderadorSumWithinLimit } from '../../../../common/ponderadores';

import './style.css'
import 'react-datepicker/dist/react-datepicker.css';
import SidePanelBaseDateContractPartie from './SidePanelBaseDateContractPartie';
import TablePolynomyItemNotAdjustment from '../../../../components/Products/sAdjustment/Polynomy/TablePolynomyItemNotAdjustment';
import MessageBoxInfoComplex from '../../../../components/Common/Message/MessageBoxInfoComplex';
import { deletePolinomio, getListFullPartidasSubPartidasPolinomios, setItemPolinomio, setItemSubpartida } from '../../../../services/sPay/partie.service';
import { _handleDeletePolynomyClick } from '../../Events';

const SidePanelInsertEditContractSubPartie = ({elementId, formView}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const numberValidDecimals = 10;
    const regexCodigoInterno = /^[A-Za-z0-9\-_]{0,50}$/;

    const {
        _contractParties: contractParties,
        _contractPartieSelected: contractPartieSelected,
        _contractSubPartieSelected: contractSubPartieSelected,
        _contractPartieSidePanelsConfig: contractPartieSidePanelsConfig,
        _contractFormSubPartieConfig: contractFormSubPartieConfig,
        _contractFormPolynomyConfig: contractFormPolynomyConfig,
    } = useSelector((state) => state.contractPartiesState);

    
    const refCodigoInterno = useRef(null);
    const [disableForm, setDisableForm] = useState(false);
    const [objContractPartie, setObjContractPartie] = useState(contractPartieSelected.iteM_PARTIDA);
    const [objContractSubPartie, setObjContractSubPartie] = useState(
        formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT ? contractSubPartieSelected : {
            iteM_SUBPARTIDA: __OBJECT_STRUCTURE_ContractSubPartie(0),
            l_SUBPOLINOMIO: [],
        }
    );
    const [objPolynomy, setObjPolynomy] = useState(__OBJECT_STRUCTURE_GetPolynomy());
    
    const [totalRestAdjustmentAmount, setTotalRestAdjustmentAmount] = useState(objContractSubPartie !== null ? __calculateTotalRestAdjustmentAmount(objContractSubPartie.l_SUBPOLINOMIO) : 0);

    const [fireVistaOnLoad, setFireVistaOnLoad] = useState(false);
 

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const [objIsValidForm, setObjIsValidForm] = useState({
        isInValidCodigoRecurso                  : false,
        isInValidCodigoInterno                  : false,
        isInvalidNombreRecurso                  : false,
        canValidateNombreRecurso                : true,
        isInvalidClasePartidaId                 : false,

        //canValidateClasePartidaId               : false,
        canValidateClasePartida                 : true,

        isInvalidTipoPartidaId                  : false,
        canValidateTipoPartidaId                : true,

        isInvalidGastoPrevioBaseRecurso         : false,
        canValidateGastoPrevioBaseRecurso       : true,

        isInvalidGastoPrevioReajusteRecurso     : false,
        canValidateGastoPrevioReajusteRecurso   : true,
        
        isInvalidGastoPrevioDiftcRecursoMc      : false,
        canValidateGastoPrevioDiftcRecursoMc    : true,
        
        isInvalidMontoTotalSumaAlzada           : false,
        canValidateMontoTotalSumaAlzada         : true,
        
        isInvalidUnidadPartida                  : false,
        canValidateUnidadPartidaId              : true,
        
        isInvalidPrecioUnitarioBase             : false,
        canValidatePrecioUnitarioBaseRecurso    : true,
        
        isInvalidCantidadUnidades               : false,
        canValidateCantidadTotalRecurso         : true,
        
        isInvalidCantidadPrevia                 : false,
        canValidateCantidadPreviaRecurso        : true,

        visible_pnlPrecioUnitario               : true,
        visible_pnlSumaAlzada                   : true,
        visible_divInfoAd                       : true,
    })

    const [objIsValidPolynomyForm, setObjIsValidPolynomyForm] = useState({
        isInvalidPolynomyType      : false,
        isInValidPonderador        : false,

        isInValidFechaBase         : false,
        isInvalidMonthOffset       : false,

        isInValidPeriodicidadMeses : false,
        isInValidPrimerMesReajuste : false,
    })
    
    useGetContractSubPartie()
    useGetSubPartieFormConfig(elementId, contractFormSubPartieConfig)
    useGetPolynomyFormConfig(contractFormPolynomyConfig)

    const isInvalidForm = () => {
        let isInvalid = false;

        isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractSubPartie.iteM_SUBPARTIDA.codigoRecurso) : isInvalid;
        objIsValidForm.isInValidCodigoRecurso = isNullUndefinedOrEmpty(objContractSubPartie.iteM_SUBPARTIDA.codigoRecurso);

        //if (!isNullUndefinedOrEmpty(objContractSubPartie.iteM_SUBPARTIDA.codigoInterno)) {
            objIsValidForm.isInValidCodigoInterno = !isNullUndefinedOrEmpty(objContractSubPartie.iteM_SUBPARTIDA.codigoInterno) ? regexCodigoInterno.test(objContractSubPartie.iteM_SUBPARTIDA.codigoInterno) : false;
        //}
        //else {
        //    objIsValidForm.isInValidCodigoInterno = true;
        //}

        if (objIsValidForm.canValidateNombreRecurso) {
            objIsValidForm.isInvalidNombreRecurso = isNullUndefinedOrEmpty(objContractSubPartie.iteM_SUBPARTIDA.nombreRecurso);
            isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractSubPartie.iteM_SUBPARTIDA.nombreRecurso) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidNombreRecurso = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidNombreRecurso : isInvalid;
        }

        if (objIsValidForm.canValidateClasePartida) {
            objIsValidForm.isInvalidClasePartidaId = isNullUndefinedOrEmptyOrZero(objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidClasePartidaId = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidClasePartidaId : isInvalid;
        }

        if (objIsValidForm.canValidateTipoPartidaId) {
            objIsValidForm.isInvalidTipoPartidaId = isNullUndefinedOrEmptyOrZero(objContractSubPartie.iteM_SUBPARTIDA.tipoPartidaId);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractSubPartie.iteM_SUBPARTIDA.tipoPartidaId) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidTipoPartidaId = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidTipoPartidaId : isInvalid;
        }

        if (objIsValidForm.canValidateGastoPrevioBaseRecurso) {
            objIsValidForm.isInvalidGastoPrevioBaseRecurso = isNullUndefinedOrEmpty(objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioBaseRecurso);
            isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioBaseRecurso) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidGastoPrevioBaseRecurso = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidGastoPrevioBaseRecurso : isInvalid;
        }
        
        if (objIsValidForm.canValidateGastoPrevioReajusteRecurso) {
            objIsValidForm.isInvalidGastoPrevioReajusteRecurso = isNullUndefinedOrEmpty(objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioReajusteRecurso);
            isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioReajusteRecurso) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidGastoPrevioReajusteRecurso = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidGastoPrevioReajusteRecurso : isInvalid;
        }

        if (objIsValidForm.canValidateGastoPrevioDiftcRecursoMc) {
            objIsValidForm.isInvalidGastoPrevioDiftcRecursoMc = isNullUndefinedOrEmpty(objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioDiftcRecursoMc);
            isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioDiftcRecursoMc) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidGastoPrevioDiftcRecursoMc = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidGastoPrevioDiftcRecursoMc : isInvalid;
        }

        if (objIsValidForm.canValidateMontoTotalSumaAlzada) {
            objIsValidForm.isInvalidMontoTotalSumaAlzada = isNullUndefinedOrEmptyOrZero(objContractSubPartie.iteM_SUBPARTIDA.montoTotalSumaAlzada);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractSubPartie.iteM_SUBPARTIDA.montoTotalSumaAlzada) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidMontoTotalSumaAlzada = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidMontoTotalSumaAlzada : isInvalid;
        }

        if (objIsValidForm.canValidateUnidadPartidaId) {
            objIsValidForm.isInvalidUnidadPartida = isNullUndefinedOrEmpty(objContractSubPartie.iteM_SUBPARTIDA.unidadPartidaId);
            isInvalid = !isInvalid ? isNullUndefinedOrEmpty(objContractSubPartie.iteM_SUBPARTIDA.unidadPartidaId) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidUnidadPartida = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidUnidadPartida : isInvalid;
        }

        if (objIsValidForm.canValidatePrecioUnitarioBaseRecurso) {
            objIsValidForm.isInvalidPrecioUnitarioBase = isNullUndefinedOrEmptyOrZero(objContractSubPartie.iteM_SUBPARTIDA.precioUnitarioBaseRecurso);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractSubPartie.iteM_SUBPARTIDA.precioUnitarioBaseRecurso) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidPrecioUnitarioBase = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidPrecioUnitarioBase : isInvalid;
        }

        if (objIsValidForm.canValidateCantidadTotalRecurso) {
            objIsValidForm.isInvalidCantidadUnidades = isNullUndefinedOrEmptyOrZero(objContractSubPartie.iteM_SUBPARTIDA.cantidadTotalRecurso);
            isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractSubPartie.iteM_SUBPARTIDA.cantidadTotalRecurso) : isInvalid;
        }
        else {
            objIsValidForm.isInvalidCantidadUnidades = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidCantidadUnidades : isInvalid;
        }

        if (objIsValidForm.canValidateCantidadPreviaRecurso) {
            if ((
                objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO &&
                contractFormSubPartieConfig.tiene_ep &&
                formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT) ?
                    true :
                    ((objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO &&
                        contractFormSubPartieConfig.tiene_ep && formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.INSERT) ?
                            true :
                            !objIsValidForm.canValidateCantidadPreviaRecurso )) {
                                objIsValidForm.isInvalidCantidadPrevia = isNullUndefinedOrEmptyOrZero(objContractSubPartie.iteM_SUBPARTIDA.cantidadPreviaRecurso);
                                isInvalid = !isInvalid ? isNullUndefinedOrEmptyOrZero(objContractSubPartie.iteM_SUBPARTIDA.cantidadPreviaRecurso) : isInvalid;           
            }
            else {
                objIsValidForm.isInvalidCantidadPrevia = false
                isInvalid = !isInvalid ? objIsValidForm.isInvalidCantidadPrevia : isInvalid;
            }
        }
        else {
            objIsValidForm.isInvalidCantidadPrevia = false
            isInvalid = !isInvalid ? objIsValidForm.isInvalidCantidadPrevia : isInvalid;
        }

        setObjIsValidForm(prevState => ({
            ...prevState,
            isInValidCodigoRecurso              : objIsValidForm.isInValidCodigoRecurso              ,
            isInValidCodigoInterno              : objIsValidForm.isInValidCodigoInterno              ,
            isInvalidNombreRecurso              : objIsValidForm.isInvalidNombreRecurso              ,
            isInvalidClasePartidaId             : objIsValidForm.isInvalidClasePartidaId             ,
            isInvalidTipoPartidaId              : objIsValidForm.isInvalidTipoPartidaId              ,
            isInvalidGastoPrevioBaseRecurso     : objIsValidForm.isInvalidGastoPrevioBaseRecurso     ,
            isInvalidGastoPrevioReajusteRecurso : objIsValidForm.isInvalidGastoPrevioReajusteRecurso ,
            isInvalidGastoPrevioDiftcRecursoMc  : objIsValidForm.isInvalidGastoPrevioDiftcRecursoMc  ,
            isInvalidMontoTotalSumaAlzada       : objIsValidForm.isInvalidMontoTotalSumaAlzada       ,
            isInvalidUnidadPartida              : objIsValidForm.isInvalidUnidadPartida              ,
            isInvalidPrecioUnitarioBase         : objIsValidForm.isInvalidPrecioUnitarioBase         ,
            isInvalidCantidadUnidades           : objIsValidForm.isInvalidCantidadUnidades           ,
            isInvalidCantidadPrevia             : objIsValidForm.isInvalidCantidadPrevia             ,
        }));

        return isInvalid;
    };
    
    const isValidPonderator = (list, newVal) => {
        // Los ponderadores pueden ser número o texto («60.00»): se suman como números (ver common/ponderadores.js).
        const ok = isPonderadorSumWithinLimit(list, newVal);

        return ok;
    }

    const isInvalidPolynomyForm = () => {
        let isInvalid = false;

        objIsValidPolynomyForm.isInValidFechaBase = isNullUndefinedOrEmpty(objPolynomy.fechaBase);
        isInvalid = !isInvalid ? objIsValidPolynomyForm.isInValidFechaBase : isInvalid;

        objIsValidPolynomyForm.isInvalidPolynomyType = isNullUndefinedOrEmptyOrZero(objPolynomy.tipoPolinomioId);
        isInvalid = !isInvalid ? objIsValidPolynomyForm.isInvalidPolynomyType : isInvalid;

        objIsValidPolynomyForm.isInValidPonderador = isNullUndefinedOrEmptyOrZero(objPolynomy.ponderador);
        isInvalid = !isInvalid ? objIsValidPolynomyForm.isInValidPonderador : isInvalid;

        objIsValidPolynomyForm.isInvalidMonthOffset = isNullUndefinedOrEmpty(objPolynomy.mesesDesfase);
        isInvalid = !isInvalid ? objIsValidPolynomyForm.isInvalidMonthOffset : isInvalid;

        objIsValidPolynomyForm.isInValidPeriodicidadMeses = isNullUndefinedOrEmpty(objPolynomy.periodicidadMeses);
        isInvalid = !isInvalid ? objIsValidPolynomyForm.isInValidPeriodicidadMeses : isInvalid;

        objIsValidPolynomyForm.isInValidPrimerMesReajuste = isNullUndefinedOrEmpty(objPolynomy.primerMesReajuste);
        isInvalid = !isInvalid ? objIsValidPolynomyForm.isInValidPrimerMesReajuste : isInvalid;

        setObjIsValidPolynomyForm(prevState => ({
            ...prevState,
            isInValidFechaBase          : objIsValidPolynomyForm.isInValidFechaBase          ,
            isInvalidPolynomyType       : objIsValidPolynomyForm.isInvalidPolynomyType       ,
            isInValidPonderador         : objIsValidPolynomyForm.isInValidPonderador         ,
            isInvalidMonthOffset        : objIsValidPolynomyForm.isInvalidMonthOffset        ,
            isInValidPeriodicidadMeses  : objIsValidPolynomyForm.isInValidPeriodicidadMeses  ,
            isInValidPrimerMesReajuste  : objIsValidPolynomyForm.isInValidPrimerMesReajuste  ,
        }));

        return isInvalid;
    };

    const handleOpenSubPartiePanel = async () => {
        setObjContractSubPartie(
            formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT ? contractSubPartieSelected : {
                iteM_SUBPARTIDA: __OBJECT_STRUCTURE_ContractSubPartie(0),
                l_SUBPOLINOMIO: [],
            }
        )

        showMessage(setMessageConfig, false, null, "")
        setDisableForm(false);
    }
        
    const handleOpenPartiePanel = async () => {
        dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_PARTIE_INSERT, true));
        dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_SUBPARTIE_INSERT, false));
    }

    const handleSaveSubPartie = async () => {
        setDisableForm(true)

        if (!isInvalidForm()) {
            const newobj = prepareSubPartieToSave()
            if (isValidPonderator(objContractSubPartie.l_SUBPOLINOMIO, 0)) {
                if (regexCodigoInterno.test(newobj.codigoInterno) === true) {
                    await setItemSubpartida(newobj).then(async (response) => {
                        setObjIsValidForm(prevState => ({ ...prevState, ["isInValidCodigoInterno"]: false }));

                        if (response.data.succeeded) {
                            if (response.data.data.result) {
                                if (response.data.data.l_messages.length > 0) {
                                
                                    //[Volver a llamar la carga de la entidad que se usa en toda la pantalla]
                                
                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_messages.map(x => `${x}<br>` ))
                                    setDisableForm(false)
                                }
                                else {
                                    const aux_objContractSubPartie = {...objContractSubPartie};
                                    aux_objContractSubPartie.iteM_SUBPARTIDA.id = response.data.data.id;
                                    setObjContractSubPartie(aux_objContractSubPartie)

                                    if (formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.INSERT) {
                                        await getListFullPartidasSubPartidasPolinomios(elementId).then((serviceResponse) => {
                                            if (serviceResponse.data.succeeded) {
                                                const responseContractParties = serviceResponse.data.data;
                            
                                                dispatch(action_updateContractPartieList(responseContractParties));
                                                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-subpartiesaved'))
                                            }
                                            else {
                                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                setDisableForm(false);
                                            }
                                        }).catch((ex) => {
                                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                            setDisableForm(false);
                                        });
                                    }
                                    else if (formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT) {
                                        await getListFullPartidasSubPartidasPolinomios(elementId).then((serviceResponse) => {
                                            if (serviceResponse.data.succeeded) {
                                                const responseContractParties = serviceResponse.data.data;
                            
                                                dispatch(action_updateContractPartieList(responseContractParties));
                                                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-subpartiesaved'))
                                            }
                                            else {
                                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                setDisableForm(false);
                                            }
                                        }).catch((ex) => {
                                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                            setDisableForm(false);
                                        });
                                    }
                                }
                            }
                            else {
                                if (response.data.data.l_messages.length > 0) {
                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_messages.map(x => `${x}<br>` ))
                                }
                                else {
                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('Se ha producido un problema al crear la subpartida.'))
                                }
                                setDisableForm(false)
                            }
                        }
                        else {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('Se ha producido un problema al crear el recurso.'))
                            setDisableForm(false)
                        }
                    }).catch((ex) => {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                        setDisableForm(false)
                    });
                }
                else {
                    setDisableForm(false);
                    setObjIsValidForm(prevState => ({ ...prevState, ["isInValidCodigoInterno"]: true }));
                }
            }
            else {
                setDisableForm(false);
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-maxponderatorerror'))
            }
        }
        else {
            setDisableForm(false)
        }
    };

    const prepareSubPartieToSave = () => {
        let newobj = __OBJECT_STRUCTURE_ContractSubPartie(objContractPartie.id);

        newobj.id = objContractSubPartie.iteM_SUBPARTIDA.id;
        newobj.elementId = elementId;
        newobj.nroRecurso = formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.INSERT ? contractFormSubPartieConfig.nro_ccorrelativo : objContractSubPartie.iteM_SUBPARTIDA.nroRecurso
        newobj.codigoRecurso = formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT ? objContractSubPartie.iteM_SUBPARTIDA.codigoRecurso : objContractSubPartie.iteM_SUBPARTIDA.codigoRecurso;
        
        let codigoInternoControlValue = null
        if (refCodigoInterno.current?.val) {
            codigoInternoControlValue = refCodigoInterno.current.val();
        } else if (refCodigoInterno.current?.getOptions) {
            codigoInternoControlValue = refCodigoInterno.current.getOptions("value");
        }

        if (objContractSubPartie.iteM_SUBPARTIDA.codigoInterno === codigoInternoControlValue) {
            newobj.codigoInterno = objContractSubPartie.iteM_SUBPARTIDA.codigoInterno;
        }
        else {
            newobj.codigoInterno = !isNullUndefined(codigoInternoControlValue) ? codigoInternoControlValue : '';
        }

        newobj.nombreRecurso = objContractSubPartie.iteM_SUBPARTIDA.nombreRecurso;
        newobj.clasePartidaId = objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId;
        newobj.tipoPartidaId = objContractSubPartie.iteM_SUBPARTIDA.tipoPartidaId;
        newobj.partidaId = objContractPartie.id;

        newobj.gastoPrevioBaseRecurso = objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioBaseRecurso;
        newobj.gastoPrevioReajusteRecurso = objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioReajusteRecurso;
        newobj.gastoPrevioDiftcRecursoMc = objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioDiftcRecursoMc;

        if (objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO)
        {
            newobj.unidadPartidaId = objContractSubPartie.iteM_SUBPARTIDA.unidadPartidaId;
            newobj.cantidadPreviaRecurso = objContractSubPartie.iteM_SUBPARTIDA.cantidadPreviaRecurso;
            newobj.cantidadTotalRecurso = objContractSubPartie.iteM_SUBPARTIDA.cantidadTotalRecurso;
            newobj.precioUnitarioBaseRecurso = objContractSubPartie.iteM_SUBPARTIDA.precioUnitarioBaseRecurso;
        }

        if (objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_SUMA_ALZADA)
        {
            newobj.montoTotalSumaAlzada = newobj.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_SUMA_ALZADA ? objContractSubPartie.iteM_SUBPARTIDA.montoTotalSumaAlzada : 0;
            newobj.unidadPartidaId = null;
        }

        return newobj;
    };

    const onDismissPanel = () => {
        if (formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.INSERT) {
            dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_SUBPARTIE_INSERT, false))
        }
        else if (formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT) {
            dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_SUBPARTIE_EDIT, false))
        }
    };

    const onClean = () => {
        setObjContractSubPartie(prevState => (formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT ? contractSubPartieSelected : {
            iteM_SUBPARTIDA: __OBJECT_STRUCTURE_ContractSubPartie(0),
            l_SUBPOLINOMIO: [],
        }));
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        <MessageBoxInfoComplex
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                            inputParam_TranslateText={true}
                            inputParam_ShowClose={true}
                        />
                    </Col>
                    <Col xl={12}>
                        {
                            !disableForm &&
                            <PrimaryButton className='mx-1' onClick={ handleSaveSubPartie }>{ t('data-lang-btn-save') }</PrimaryButton>
                        }
                        {
                            disableForm &&
                            <>
                                <PrimaryButton className='mx-1' onClick={ handleOpenPartiePanel }>{ t('data-lang-btn-createpartie') }</PrimaryButton>
                                <PrimaryButton className='mx-1' onClick={ handleOpenSubPartiePanel }>{ t('data-lang-btn-createsubpartie') }</PrimaryButton>
                            </>
                        }
                        <DefaultButton className='mx-1' onClick={ onClean }>{ t('data-lang-btn-clean') }</DefaultButton>
                        <DefaultButton className='mx-1' onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const onChangeObjPartieString = (event, fieldName, isInvalidPropertyField) => {
        // El campo numérico vuelve a avisar «change» cada vez que React lo redibuja, aunque el valor sea el mismo.
        // Si no cambió, no se toca el estado: hacerlo provoca un ciclo infinito (React error 185).
        if (isSameNumberInputValue(objContractSubPartie.iteM_SUBPARTIDA[fieldName], event.args.value)) {
            return;
        }

        commonObjPartieInputSetterValue(event.args.value, fieldName, isInvalidPropertyField)
    };

    const onChangeObjPartieTextInputString = (event, fieldName, isInvalidPropertyField) => {
        if (fieldName === 'codigoInterno') {
            if (!isNullUndefined(event.currentTarget.value)) {
                if (regexCodigoInterno.test(event.currentTarget.value) === true) {
                    commonObjPartieInputSetterValue(event.currentTarget.value, fieldName, isInvalidPropertyField)
                }
                else {
                    setObjContractSubPartie(prevState => ({
                        ...prevState,
                        iteM_SUBPARTIDA: {
                            ...prevState.iteM_SUBPARTIDA,
                            [fieldName]: event.currentTarget.value,
                        }
                    }));
                    setObjIsValidForm(prevState => ({ ...prevState, [isInvalidPropertyField]: true }));
                }
            }
            else {
                commonObjPartieInputSetterValue('', fieldName, isInvalidPropertyField)
            }
        }
        else {
            commonObjPartieInputSetterValue(event.currentTarget.value, fieldName, isInvalidPropertyField)
        }
    };

    const commonObjPartieInputSetterValue = (value, fieldName, isInvalidPropertyField) => {
        let isInValidValue = isNullUndefinedOrEmpty(value);

        if (fieldName === 'codigoInterno') {
            if (!isNullUndefinedOrEmpty(value)) {
                if (regexCodigoInterno.test(value) === true) {
                    isInValidValue = false;
                }
            }
            else {
                isInValidValue = false;
            }
        }

        objContractSubPartie.iteM_SUBPARTIDA[fieldName] = value;

        setObjContractSubPartie(prevState => ({
            ...prevState,
            iteM_SUBPARTIDA: {
                ...prevState.iteM_SUBPARTIDA,
                [fieldName]: objContractSubPartie.iteM_SUBPARTIDA[fieldName],
            }
        }));

        setObjIsValidForm(prevState => ({ ...prevState, [isInvalidPropertyField]: isInValidValue }));
    }

    const onChangeObjPolynomyString = (event, fieldName) => {
        commonObjPolynomyInputSetterValue(event.args.value, fieldName)
    };

    const onChangeObjPolynomyTextInputString = (event, fieldName) => {
        commonObjPolynomyInputSetterValue(event.currentTarget.value, fieldName)
    };

    const commonObjPolynomyInputSetterValue = (value, fieldName) => {
        objPolynomy[fieldName] = value;
        setObjPolynomy(objPolynomy)
    }

    const handleSelectClass = (ev, item) => {
        const isInValidValue = isNullUndefinedOrEmpty(item.key) || item.key === 0;
        const currentItem = contractFormSubPartieConfig.l_CLASE.find(x => x.id === item.key);

        if (!isNullUndefinedOrEmpty(currentItem)) {
            objContractSubPartie.iteM_SUBPARTIDA.clasePartidaTitle = currentItem.title;
            objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId = currentItem.id;
        }
        else {
            objContractSubPartie.iteM_SUBPARTIDA.clasePartidaTitle = '';
            objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId = 0;
        }

        setObjContractSubPartie(prevState => ({
            ...prevState,
            iteM_SUBPARTIDA: {
                ...prevState.iteM_SUBPARTIDA,
                clasePartidaTitle: objContractSubPartie.iteM_SUBPARTIDA.clasePartidaTitle,
                clasePartidaId: objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId,
            }
        }));

        setObjIsValidForm(prevState => ({ ...prevState, isInvalidSubPartieClass: isInValidValue }));

        Vista();
    };
    const handleSelectType = (ev, item) => {
        const isInValidValue = isNullUndefinedOrEmpty(item.key) || item.key === 0;
        const currentItem = contractFormSubPartieConfig.l_TIPO.find(x => x.id === item.key);

        if (!isNullUndefinedOrEmpty(currentItem)) {
            objContractSubPartie.iteM_SUBPARTIDA.tipoPartidaTitle = currentItem.title;
            objContractSubPartie.iteM_SUBPARTIDA.tipoPartidaId = currentItem.id;
        }
        else {
            objContractSubPartie.iteM_SUBPARTIDA.tipoPartidaTitle = '';
            objContractSubPartie.iteM_SUBPARTIDA.tipoPartidaId = 0;
        }

        setObjContractSubPartie(prevState => ({
            ...prevState,
            iteM_SUBPARTIDA: {
                ...prevState.iteM_SUBPARTIDA,
                tipoPartidaTitle: objContractSubPartie.iteM_SUBPARTIDA.tipoPartidaTitle,
                tipoPartidaId: objContractSubPartie.iteM_SUBPARTIDA.tipoPartidaId,
            }
        }));

        setObjIsValidForm(prevState => ({ ...prevState, isInvalidSubPartieType: isInValidValue }));
    };
    const handleSelectServiceUnit = (ev, item) => {
        const isInValidValue = isNullUndefinedOrEmpty(item.key) || item.key === 0;
        const currentItem = contractFormSubPartieConfig.l_UNIDAD.find(x => x.id === item.key);
        if (!isNullUndefinedOrEmpty(currentItem)) {
            objContractSubPartie.iteM_SUBPARTIDA.unidadPartidaTitle = currentItem.title;
            objContractSubPartie.iteM_SUBPARTIDA.unidadPartidaId = currentItem.id;
        }
        else {
            objContractSubPartie.iteM_SUBPARTIDA.unidadPartidaTitle = '';
            objContractSubPartie.iteM_SUBPARTIDA.unidadPartidaId = 0;
        }
        
        setObjContractSubPartie(prevState => ({
            ...prevState,
            iteM_SUBPARTIDA: {
                ...prevState.iteM_SUBPARTIDA,
                unidadPartidaTitle: objContractSubPartie.iteM_SUBPARTIDA.unidadPartidaTitle,
                unidadPartidaId: objContractSubPartie.iteM_SUBPARTIDA.unidadPartidaId,
            }
        }));

        setObjIsValidForm(prevState => ({ ...prevState, isInvalidUnidadPartida: isInValidValue }));
    };
    const handleSelectPolynomyType = (ev, item) => {
        const currentItem = contractFormPolynomyConfig.l_TIPO_POLINOMIO.find(x => x.id === item.key);

        setObjPolynomy(prevState => ({
            ...prevState,
            tipoPolinomioId: currentItem.id,
            tipoPolinomioTitle: currentItem.title
        }));
    };
    const handleSelectMonthDiff = (ev, item) => {
        const currentItem = contractFormPolynomyConfig.l_MESES_DESFASE.find(x => x === item.key);

        setObjPolynomy(prevState => ({
            ...prevState,
            mesesDesfase: currentItem
        }));
    };
    const handlePolynomyDateChange = (value, controlName) => {
        let isInValidValue = isNullUndefinedOrEmpty(value) || value === "0000/00";
        objPolynomy[controlName] = moment(value).format('YYYY/MM');
        setObjPolynomy(objPolynomy)
        setObjIsValidPolynomyForm(prevState => ({ ...prevState, isInValidMesPrevio: isInValidValue }));
    }

    const handleSetPolynomyBaseDate = (objectBaseDate) => {
        setObjPolynomy(prevState => ({
            ...prevState,
            valorBase: objectBaseDate.valor,
            fechaBase: objectBaseDate.fecha
        }));

        setIsDialogOpen(false);
    }

    const handleSavePolynomy = async () => {
        const newobj = preparePolynomyToSave()
        if (!isInvalidPolynomyForm()) {
            if (isValidPonderator(objContractSubPartie.l_SUBPOLINOMIO, newobj.ponderador)) {
                await setItemPolinomio(newobj).then((response) => {
                    if (response.data.succeeded) {
                        if (response.data.data.result) {
                            if (response.data.data.l_messages.length > 0) {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_messages.map(x => `${x}<br>` ))
                            }
                            else {
                                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-polynomysaved'))
                                newobj.id = response.data.data.id;
                                dispatch(action_addSubPartiePolinomy(objContractSubPartie.id, newobj));
                                setObjPolynomy(prevState => ({
                                    ...prevState,
                                    id: null,
                                    tipoPolinomioId: null,
                                    tipoPolinomioTitle: null,
                                    ponderador: null,
                                    fechaBase: null,
                                    valorBase: null,
                                    mesesDesfase: null,
                                    periodicidadMeses: null,
                                    primerMesReajuste: null,
                                }))

                                const aux_objContractSubPartie = {...objContractSubPartie}
                                
                                aux_objContractSubPartie.l_SUBPOLINOMIO.push(newobj);

                                setObjContractSubPartie(aux_objContractSubPartie)

                                setTotalRestAdjustmentAmount(totalRestAdjustmentAmount - newobj.ponderador)
                            }
                        }
                        else {
                            if (response.data.data.l_messages.length > 0) {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_messages.map(x => `${x}<br>` ))
                            }
                            else {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-polynomysavederror'))
                            }
                        }
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-polynomysavederror'))
                    }
                }).catch((ex) => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                });
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-maxponderatorerror'))
            }
        }
    };

    const onSelectBaseDateDialog = () => {
        setIsDialogOpen(true);
    }

    const Vista = () => {
        if (formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.INSERT || formView == enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT)
        {
            let textDate = contractPartieSelected.iteM_PARTIDA.mesPrevio ?? "";
            textDate = isNullOrEmpty(textDate) ? "0000/00" : textDate;
            const flag = textDate === "0000/00";

            
            if (objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId > 0)
            {
                objIsValidForm.canValidateMontoTotalSumaAlzada       = objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_SUMA_ALZADA     ? true : false;
                objIsValidForm.canValidateUnidadPartidaId = objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO ? true : false;
                objIsValidForm.canValidatePrecioUnitarioBaseRecurso   = objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO ? true : false;
                objIsValidForm.canValidateCantidadTotalRecurso = objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO ? true : false;

                const aux_objContractSubPartie = {...objContractSubPartie};
                const ReadOnlyControlesPrevios = contractFormSubPartieConfig.tiene_ep ? true : flag ? true : false;

                objIsValidForm.canValidateGastoPrevioBaseRecurso = !ReadOnlyControlesPrevios;
                aux_objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioBaseRecurso = aux_objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioBaseRecurso;

                objIsValidForm.canValidateGastoPrevioReajusteRecurso = !ReadOnlyControlesPrevios;
                aux_objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioReajusteRecurso = aux_objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioReajusteRecurso;
                
                if (objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId == enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO)
                {
                    objIsValidForm.canValidateCantidadPreviaRecurso = !ReadOnlyControlesPrevios

                    aux_objContractSubPartie.iteM_SUBPARTIDA.cantidadPreviaRecurso = ReadOnlyControlesPrevios ? 0 : aux_objContractSubPartie.iteM_SUBPARTIDA.cantidadPreviaRecurso;
                }

                setObjContractSubPartie(aux_objContractSubPartie)

                objIsValidForm.visible_pnlSumaAlzada     = objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_SUMA_ALZADA ? true : false;
                objIsValidForm.visible_pnlPrecioUnitario = objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO ? true : false;
            }

            objIsValidForm.visible_divInfoAd  = objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_SUMA_ALZADA || objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO ? true : false;
            objIsValidForm.visible_pnlSumaAlzada  = objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_SUMA_ALZADA ? true : false;
            objIsValidForm.visible_pnlPrecioUnitario  = objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO ? true : false;

            var moneda_id = objContractSubPartie.iteM_SUBPARTIDA.ID_MONEDA_PARTIDA ?? 0;
            let flag_moneda = true;
            
            if (moneda_id > 0)
            {
                flag_moneda = objContractSubPartie.iteM_SUBPARTIDA.MonedaContrato.ID !== moneda_id ? false : true;
            }
            if (!flag_moneda)
            {
                flag_moneda = flag;
            }

            const gastoPrevioDiftcPartidaMcReadOnly = (contractFormSubPartieConfig.tiene_ep ? true : flag_moneda);

            objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioDiftcPartidaMc = gastoPrevioDiftcPartidaMcReadOnly ? 0 : objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioDiftcPartidaMc
            objIsValidForm.canValidateGastoPrevioDiftcRecursoMc = !flag_moneda;
            
            setObjIsValidForm(prevState => ({
                ...prevState,
                visible_divInfoAd: objIsValidForm.visible_divInfoAd,
                visible_pnlSumaAlzada: objIsValidForm.visible_pnlSumaAlzada,
                visible_pnlPrecioUnitario: objIsValidForm.visible_pnlPrecioUnitario,
              
                canValidateMontoTotalSumaAlzada: objIsValidForm.canValidateMontoTotalSumaAlzada,
                canValidateUnidadPartidaId: objIsValidForm.canValidateUnidadPartidaId,
                canValidatePrecioUnitarioBaseRecurso: objIsValidForm.canValidatePrecioUnitarioBaseRecurso,
                canValidateCantidadTotalRecurso: objIsValidForm.canValidateCantidadTotalRecurso,
                canValidateCantidadPreviaRecurso: objIsValidForm.canValidateCantidadPreviaRecurso,
                canValidateGastoPrevioDiftcRecursoMc: objIsValidForm.canValidateGastoPrevioDiftcRecursoMc,
            }));

            setObjContractSubPartie(prevState => ({
                ...prevState,
                iteM_SUBPARTIDA: {
                    ...prevState.iteM_SUBPARTIDA,
                    gastoPrevioDiftcPartidaMc: objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioDiftcPartidaMc,
                }
            }));
        }
    }

    const Fill = () => {
        if (isNullUndefinedOrEmpty(contractFormSubPartieConfig.l_CLASE.find(x => x.id === 0))) {
            contractFormSubPartieConfig.l_CLASE.unshift({id: 0, title: t('data-lang-lbl-select'), tipoClase: null, tipoPartida: null})
        }

        if (isNullUndefinedOrEmpty(contractFormSubPartieConfig.l_MONEDA.find(x => x.id === 0))) {
            contractFormSubPartieConfig.l_MONEDA.unshift({id: 0, name: t('data-lang-lbl-select'), code: null, type: null})
        }
        
        if (isNullUndefinedOrEmpty(contractFormSubPartieConfig.l_TIPO.find(x => x.id === 0))) {
            contractFormSubPartieConfig.l_TIPO.unshift({id: 0, title: t('data-lang-lbl-select'), tipoClase: null, tipoPartida: null})
        }

        if (isNullUndefinedOrEmpty(contractFormSubPartieConfig.l_UNIDAD.find(x => x.id === 0))) {
            contractFormSubPartieConfig.l_UNIDAD.unshift({id: 0, title: t('data-lang-lbl-select')})
        }

        dispatch(action_updateFormConfigSubPartie(contractFormSubPartieConfig))

        Vista();
        //OnUserControlSubPartidaModeChanged();
    }

    const handleDeletePolynomyClick = async (tableItemId, parentId, _contractParties) =>{
        await deletePolinomio(tableItemId).then((response) => {
            if (response.data.succeeded) {
                let currentValue = 0;
                const aux_contractSubParties = _contractParties.map(partie => {
                    return {
                        ...partie,
                        l_SUBPARTIDA: partie.l_SUBPARTIDA.map(subpartie => {
                            if (subpartie.id === parentId) {
                                currentValue = subpartie.l_SUBPOLINOMIO.find(polinomy => polinomy.id === tableItemId).ponderador;
                                return {
                                    ...subpartie,
                                    l_SUBPOLINOMIO: subpartie.l_SUBPOLINOMIO.filter(polinomy => polinomy.id !== tableItemId)
                                };
                            }
                            return subpartie;
                        })
                    };
                });

                dispatch(action_updateContractPartieList(aux_contractSubParties));

                try {
                    setObjContractSubPartie(aux_contractSubParties.flatMap(partie => partie.l_SUBPARTIDA).find(x => x.id = parentId))
                } catch (error) {
                    
                }

                setTotalRestAdjustmentAmount(parseFloat(totalRestAdjustmentAmount) + parseFloat(currentValue))
            }
            else {

            }
        }).catch(() => {

        });
    }

    const preparePolynomyToSave = () => {
        let newobj = {
            id: isNullUndefinedOrEmpty(objPolynomy.id) ? 0 : objPolynomy.id,
            partidaId: objContractPartie.id,
            subpartidaId: objContractSubPartie.id,
            fechaBase: !isNullUndefinedOrEmpty(objPolynomy.fechaBase) ? moment(objPolynomy.fechaBase, 'DD/MM/YYYY') : null,
            mesesDesfase: objPolynomy.mesesDesfase,
            periodicidadMeses: objPolynomy.periodicidadMeses,
            ponderador: objPolynomy.ponderador,
            primerMesReajuste: objPolynomy.primerMesReajuste,
            tipoPolinomioId: objPolynomy.tipoPolinomioId,
            tipoPolinomioTitle: objPolynomy.tipoPolinomioTitle,
            valorBase: objPolynomy.valorBase,
        }

        return newobj;
    };

    useEffect(() => {
        const handleWheel = (event) => {
            event.preventDefault();
        };
    
        const numberInputs = document.querySelectorAll('.jqx-numberinput');
    
        numberInputs.forEach((input) => {
            input.addEventListener('wheel', handleWheel);
        });
    
        return () => {
            numberInputs.forEach((input) => {
                input.removeEventListener('wheel', handleWheel);
            });
        };
    }, []);

    useEffect(() => {
        const handleWheel = (event) => {
            event.preventDefault();
        };
    
        const numberInputs = document.querySelectorAll('.jqx-input-content');
    
        numberInputs.forEach((input) => {
            input.addEventListener('wheel', handleWheel);
        });
    
        return () => {
            numberInputs.forEach((input) => {
                input.removeEventListener('wheel', handleWheel);
            });
        };
    }, []);

    useEffect(() => {
        if (fireVistaOnLoad === false && !isNullUndefined(contractFormSubPartieConfig) && !isNullUndefined(contractSubPartieSelected)) {
            setFireVistaOnLoad(true);
            Vista();
        }    
    }, [contractFormSubPartieConfig, contractSubPartieSelected, fireVistaOnLoad, setFireVistaOnLoad]);
    

    return (
        <div>
            <Panel
                isOpen={ contractPartieSidePanelsConfig.isPanelEditSubPartieOpen || contractPartieSidePanelsConfig.isPanelInsertSubPartieOpen }
                isBlocking={true}
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-subpartieform') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                type={PanelType.custom}
                customWidth="950px"
                isLightDismiss={false}
            >
                {
                    contractFormSubPartieConfig && contractFormPolynomyConfig && objContractSubPartie && objContractSubPartie.iteM_SUBPARTIDA &&
                    <fieldset disabled={disableForm}>
                        <div className='pt-4'>
                            <div style={{borderBottom: "1px solid #999"}}><h5>{ t('data-lang-lbl-contractpartie-partieinfo') }</h5></div>
                            <Row className='pt-1'>
                                <Col xs={12} xl={12}>
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-name') } labelValue={ objContractPartie.nombrePartida } />
                                </Col>
                            </Row>
                            <Row className='pt-1'>
                                 <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partienumber') } labelValue={ objContractPartie.nroPartida } />
                                 </Col>
                                 <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partiecode') } labelValue={ objContractPartie.codigoPartida } />
                                 </Col>
                            </Row>
                            <Row className='pt-1'>
                                 <Col xs={12} xl={6}>
                                     <CLabel labelText={ t('data-lang-lbl-contractpartie-partietype') } labelValue={ objContractPartie.tipoPartidaTitle } />
                                 </Col>
                                 <Col xs={12} xl={6} className="mt-1">
                                     <CLabel labelText={ t('data-lang-lbl-contractpartie-partieclass') } labelValue={ objContractPartie.clasePartidaTitle } />
                                 </Col>
                            </Row>
                            <Row className='pt-1'>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-partiecurrency') } labelValue={ objContractPartie.monedaPartida }  />
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                     <CLabel labelText={ t('data-lang-lbl-contractpartie-partieprevmonth') } labelValue={ objContractPartie.mesPrevio } />
                                 </Col>
                            </Row>
                        </div>
                        <div className='pt-4'>
                             <div style={{borderBottom: "1px solid #999"}}><h5>{ t('data-lang-lbl-contractpartie-subpartieinfo') }</h5></div>
                            <Row className='pt-1'>
                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartiecode') } />
                                    <JqxInput
                                        height={25}
                                        width={"100%"}
                                        value={objContractSubPartie.iteM_SUBPARTIDA.codigoRecurso}
                                        onChange={(e) => onChangeObjPartieTextInputString(e, 'codigoRecurso', 'isInValidCodigoRecurso')}
                                    />
                                    <div id='rqPartidaCodigo'>
                                        <CValidator isInValid={objIsValidForm.isInValidCodigoRecurso} inValidText={t('data-lang-msg-required')} /> 
                                    </div>
                                </Col>
                                {
                                    formView !== enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.INSERT &&
                                    <Col xs={12} xl={6} className="mt-1">
                                        <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartienumber') } labelValue={ formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.INSERT ? contractFormSubPartieConfig.nro_ccorrelativo : objContractSubPartie.iteM_SUBPARTIDA.nroRecurso } />
                                    </Col>
                                }
                            </Row>
                            <Row className='pt-1'>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartiename') } /><br/>
                                    <JqxInput
                                        height={25}
                                        width={"100%"}
                                        value={objContractSubPartie.iteM_SUBPARTIDA.nombreRecurso}
                                        disabled={(formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT) ? true : !objIsValidForm.canValidateClasePartida}
                                        onChange={(e) => onChangeObjPartieTextInputString(e, 'nombreRecurso', 'isInvalidNombreRecurso')}
                                    />
                                    {
                                        objIsValidForm.canValidateNombreRecurso &&
                                        <div id='rfvtxtNombreRecurso'>
                                            <CValidator isInValid={objIsValidForm.isInvalidNombreRecurso} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartieclass') } />
                                    <Dropdown
                                        placeholder={t('data-lang-lbl-contractpartie-subpartieclass')}
                                        options={contractFormSubPartieConfig.l_CLASE !== null ? contractFormSubPartieConfig.l_CLASE.map(item => { return  { key: item.id, text: item.title } }) : []}
                                        selectedKey={objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId}
                                        onChange={handleSelectClass}
                                        checkable
                                        disabled={(formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT) ? true : !objIsValidForm.canValidateClasePartida}
                                        styles={ {title: { height: "27px" }} }
                                        className="mb-1"
                                    />
                                    {
                                        objIsValidForm.canValidateClasePartida &&
                                        <div id='rfvddlSubPartieClass'>
                                            <CValidator isInValid={objIsValidForm.isInvalidClasePartidaId} isInvalidText={!objIsValidForm.isInvalidClasePartidaId ? "" : null} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }
                                </Col>
                            </Row>
                            <Row className='pt-1'>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartietype') } />
                                    <Dropdown
                                        placeholder={t('data-lang-lbl-contractpartie-subpartietype')}
                                        options={contractFormSubPartieConfig.l_TIPO !== null ? contractFormSubPartieConfig.l_TIPO.map(item => { return  { key: item.id, text: item.title } }) : []}
                                        selectedKey={objContractSubPartie.iteM_SUBPARTIDA.tipoPartidaId}
                                        onChange={handleSelectType}
                                        checkable
                                        disabled={(formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT) ? true : !objIsValidForm.canValidateTipoPartidaId}
                                        styles={ {title: { height: "27px" }} }
                                        className="mb-1"
                                    />
                                    {
                                        objIsValidForm.canValidateTipoPartidaId &&
                                        <div id='rfvddlSubPartieType'>
                                            <CValidator isInValid={objIsValidForm.isInvalidTipoPartidaId} isInvalidText={!objIsValidForm.isInvalidTipoPartidaId ? "" : null} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartieprevmonthexpensebase') } />
                                    <JqxNumberInput
                                        max={999999999999999}
                                        height={25}
                                        width={"100%"}
                                        decimalDigits={numberValidDecimals}
                                        digits={19}
                                        symbolPosition={'right'}
                                        value={objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioBaseRecurso}
                                        groupSeparator= ','
                                        decimalSeparator= '.'
                                        //OJO
                                        disabled={(contractFormSubPartieConfig.tiene_ep && formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT) ? true : ((contractFormSubPartieConfig.tiene_ep && formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.INSERT) ? true : !objIsValidForm.canValidateGastoPrevioBaseRecurso )}
                                        onChange={(e) => onChangeObjPartieString(e, 'gastoPrevioBaseRecurso', 'isInvalidGastoPrevioBaseRecurso')}
                                    />
                                    {
                                        objIsValidForm.canValidateGastoPrevioBaseRecurso &&
                                        <div id='rfvtxtGastoPrevioBaseRecurso'>
                                            <CValidator isInValid={objIsValidForm.isInvalidGastoPrevioBaseRecurso} isInvalidText={!objIsValidForm.isInvalidGastoPrevioBaseRecurso ? "" : null} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }
                                </Col>
                            </Row>
                            <Row className='pt-1'>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartieprevexpensemonthadjunst') } />
                                    <JqxNumberInput
                                        max={999999999999999}
                                        height={25}
                                        width={"100%"}
                                        decimalDigits={numberValidDecimals}
                                        digits={19}
                                        symbolPosition={'right'}
                                        value={objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioReajusteRecurso}
                                        groupSeparator= ','
                                        decimalSeparator= '.'
                                        disabled={(contractFormSubPartieConfig.tiene_ep && formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT) ? true : ((contractFormSubPartieConfig.tiene_ep && formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.INSERT) ? true : !objIsValidForm.canValidateGastoPrevioReajusteRecurso )}
                                        onChange={(e) => onChangeObjPartieString(e, 'gastoPrevioReajusteRecurso', 'isInvalidGastoPrevioReajusteRecurso')}
                                    />
                                    {
                                        objIsValidForm.canValidateGastoPrevioReajusteRecurso &&
                                        <div id='rfvtxtGastoPrevioReajusteRecurso'>
                                            <CValidator isInValid={objIsValidForm.isInvalidGastoPrevioReajusteRecurso} isInvalidText={!objIsValidForm.isInvalidGastoPrevioReajusteRecurso ? "" : null} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartieprevexpensedifference') } />
                                    <JqxNumberInput
                                        max={999999999999999}
                                        height={25}
                                        width={"100%"}
                                        decimalDigits={numberValidDecimals}
                                        digits={19}
                                        symbolPosition={'right'}
                                        value={objContractSubPartie.iteM_SUBPARTIDA.gastoPrevioDiftcRecursoMc}
                                        groupSeparator= ','
                                        decimalSeparator= '.'
                                        disabled={!objIsValidForm.canValidateGastoPrevioDiftcRecursoMc}
                                        onChange={(e) => onChangeObjPartieString(e, 'gastoPrevioDiftcRecursoMc','isInvalidGastoPrevioDiftcRecursoMc')}
                                    />
                                    {
                                        objIsValidForm.canValidateGastoPrevioDiftcRecursoMc &&
                                        <div id='rfvtxtGastoPrevioDiftcRecursoMc'>
                                            <CValidator isInValid={objIsValidForm.isInvalidGastoPrevioDiftcRecursoMc} isInvalidText={!objIsValidForm.isInvalidGastoPrevioDiftcRecursoMc ? "" : null} inValidText={t('data-lang-msg-required')} /> 
                                        </div>
                                    }
                                </Col>
                            </Row>
                        </div>
                        <div id="divInfoAd" className='pt-4'>
                            <div style={{borderBottom: "1px solid #999"}}><h5>{ t('data-lang-lbl-contractpartie-aditionalsubpartieinfo') }</h5></div>
                            <Row className='pt-1'>
                                {
                                    objIsValidForm.visible_pnlSumaAlzada &&
                                    <Col id="pnlSumaAlzada" xs={12} xl={6}>
                                        <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartietotalamountsumalz') } />
                                        <JqxNumberInput
                                            max={999999999999999}
                                            height={25}
                                            width={"100%"}
                                            decimalDigits={numberValidDecimals}
                                            digits={19}
                                            symbolPosition={'right'}
                                            value={objContractSubPartie.iteM_SUBPARTIDA.montoTotalSumaAlzada}
                                            groupSeparator= ','
                                            decimalSeparator= '.'
                                            disabled={!objIsValidForm.canValidateMontoTotalSumaAlzada}
                                            onChange={(e) => onChangeObjPartieString(e, 'montoTotalSumaAlzada', 'isInvalidMontoTotalSumaAlzada')}
                                        />
                                        {
                                            objIsValidForm.canValidateMontoTotalSumaAlzada &&
                                            <div id='rfvtxtMontoTotal'>
                                                <CValidator isInValid={objIsValidForm.isInvalidMontoTotalSumaAlzada} inValidText={t('data-lang-msg-required')} /> 
                                            </div>
                                        }
                                    </Col>
                                }
                                {
                                    objIsValidForm.visible_pnlPrecioUnitario &&
                                    <Col xs={12} xl={6} className="mt-1">
                                        <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartieserviceunit') } />
                                        <Dropdown
                                            placeholder={t('data-lang-lbl-contractpartie-subpartieserviceunit')}
                                            options={contractFormSubPartieConfig.l_UNIDAD !== null ? contractFormSubPartieConfig.l_UNIDAD.map(item => { return  { key: item.id, text: item.title } }) : []}
                                            selectedKey={objContractSubPartie.iteM_SUBPARTIDA.unidadPartidaId}
                                            onChange={handleSelectServiceUnit}
                                            checkable
                                            disabled={(formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT) ? true : !objIsValidForm.canValidateUnidadPartidaId}
                                            styles={ {title: { height: "27px" }} }
                                            className="mb-1"
                                        />
                                        {
                                            objIsValidForm.canValidateUnidadPartidaId &&
                                            <div id='rfvddlUnidadSubPartida'>
                                                <CValidator isInValid={objIsValidForm.isInvalidUnidadPartida} inValidText={t('data-lang-msg-required')} /> 
                                            </div>
                                        }
                                    </Col>
                                }
                            </Row>
                            {
                                objIsValidForm.visible_pnlPrecioUnitario &&
                                <div  id="pnlPrecioUnitario">
                                    <Row className='pt-1'>
                                        <Col xs={12} xl={6} className="mt-1">
                                            <CLabel labelText={ t('data-lang-lbl-contractpartie-subpartieunitpricebase') } />
                                            <JqxNumberInput
                                                max={999999999999999}
                                                height={25}
                                                width={"100%"}
                                                decimalDigits={numberValidDecimals}
                                                digits={19}
                                                symbolPosition={'right'}
                                                value={parseFloat(objContractSubPartie.iteM_SUBPARTIDA.precioUnitarioBaseRecurso)}
                                                groupSeparator= ','
                                                decimalSeparator= '.'
                                                disabled={!objIsValidForm.canValidatePrecioUnitarioBaseRecurso}
                                                onChange={(e) => onChangeObjPartieString(e, 'precioUnitarioBaseRecurso','isInvalidPrecioUnitarioBase')}
                                            />
                                            {
                                                objIsValidForm.canValidatePrecioUnitarioBaseRecurso &&
                                                <div id='rfvtxtPrecioUnitario'>
                                                    <CValidator isInValid={objIsValidForm.isInvalidPrecioUnitarioBase} inValidText={t('data-lang-msg-required')} /> 
                                                </div>
                                            }
                                        </Col>
                                        <Col xs={12} xl={6} className="mt-1">
                                            <CLabel labelText={ t('data-lang-lbl-contractpartie-totalsubpartieamount') } />
                                            <JqxNumberInput
                                                max={999999999999999}
                                                height={25}
                                                width={"100%"}
                                                decimalDigits={numberValidDecimals}
                                                digits={19}
                                                symbolPosition={'right'}
                                                value={objContractSubPartie.iteM_SUBPARTIDA.cantidadTotalRecurso}
                                                groupSeparator= ','
                                                decimalSeparator= '.'
                                                disabled={!objIsValidForm.canValidateCantidadTotalRecurso}
                                                onChange={(e) => onChangeObjPartieString(e, 'cantidadTotalRecurso','isInvalidCantidadUnidades')}
                                            />
                                            {
                                                objIsValidForm.canValidateCantidadTotalRecurso &&
                                                <div id='rfvtxtCantidadUnidades'>
                                                    <CValidator isInValid={objIsValidForm.isInvalidCantidadUnidades} inValidText={t('data-lang-msg-required')} /> 
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className='pt-1'>
                                        <Col xs={12} xl={6} className="mt-1">
                                            <CLabel labelText={ t('data-lang-lbl-contractpartie-prevsubpartieamount') } />
                                            <JqxNumberInput
                                                max={999999999999999}
                                                height={25}
                                                width={"100%"}
                                                decimalDigits={numberValidDecimals}
                                                digits={19}
                                                symbolPosition={'right'}
                                                value={objContractSubPartie.iteM_SUBPARTIDA.cantidadPreviaRecurso}
                                                groupSeparator= ','
                                                decimalSeparator= '.'
                                                //OJO
                                                disabled={(
                                                    objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO &&
                                                    contractFormSubPartieConfig.tiene_ep &&
                                                    formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT) ?
                                                        true :
                                                        ((objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO &&
                                                            contractFormSubPartieConfig.tiene_ep && formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.INSERT) ?
                                                                true :
                                                                !objIsValidForm.canValidateCantidadPreviaRecurso )}
                                                onChange={(e) => onChangeObjPartieString(e, 'cantidadPreviaRecurso','isInvalidCantidadPrevia')}
                                            />
                                            {
                                                !(
                                                    objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO &&
                                                    contractFormSubPartieConfig.tiene_ep &&
                                                    formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT) ?
                                                        true :
                                                        ((objContractSubPartie.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO &&
                                                            contractFormSubPartieConfig.tiene_ep && formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.INSERT) ?
                                                                true :
                                                                !objIsValidForm.canValidateCantidadPreviaRecurso ) &&
                                                <div id='rfvtxtPUCantidadPrevia'>
                                                    <CValidator isInValid={objIsValidForm.isInvalidCantidadPrevia} inValidText={t('data-lang-msg-required')} /> 
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                </div>
                            }
                            <Row className='pt-1'>
                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-internalcode') } />
                                    <JqxInput
                                        height={25}
                                        ref={refCodigoInterno}
                                        width={"100%"}
                                        value={!isNullUndefined(objContractSubPartie.iteM_SUBPARTIDA.codigoInterno) ? objContractSubPartie.iteM_SUBPARTIDA.codigoInterno : '' }
                                        onChange={(e) => onChangeObjPartieTextInputString(e, 'codigoInterno', 'isInValidCodigoInterno')}
                                    />
                                    <div id='rqPartidaCodigo'>
                                        <CValidator isInValid={objIsValidForm.isInValidCodigoInterno} inValidText={t('data-lang-msg-lettersnumbersandhyphenunderscore')} /> 
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        {
                            formView === enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT &&
                            <div className='pt-4'>
                                <div style={{borderBottom: "1px solid #999"}}><h5>{ t('data-lang-lbl-contractpartie-polynomyadjustment') }</h5></div>
                                <Row className='pt-1'>
                                    <Col xs={12} xl={6}>
                                        <CLabel labelText={ t('data-lang-lbl-contractpartie-polynomyname') } />
                                        <Dropdown
                                            placeholder={t('data-lang-lbl-contractpartie-polynomyname')}
                                            options={contractFormPolynomyConfig.l_TIPO_POLINOMIO !== null ? contractFormPolynomyConfig.l_TIPO_POLINOMIO.map(item => { return  { key: item.id, text: item.title } }) : []}
                                            selectedKey={objPolynomy.tipoPolinomioId}
                                            onChange={handleSelectPolynomyType}
                                            checkable
                                            styles={ {title: { height: "27px" }} }
                                            className="mb-1"
                                        />
                                        <CValidator isInValid={objIsValidPolynomyForm.isInvalidPolynomyType} isInvalidText={!objIsValidPolynomyForm.isInvalidPolynomyType ? "" : null} inValidText={t('data-lang-msg-required')} />
                                    </Col>
                                    <Col xs={12} xl={6} className="mt-1">
                                        <CLabel labelText={ t('data-lang-lbl-contractpartie-ponderator') } />
                                        <JqxNumberInput
                                            max={100}
                                            inputMode="simple"
                                            width={80}
                                            height={25}
                                            symbolPosition={'right'}
                                            symbol={'%'}
                                            digits={3}
                                            groupSeparator= ','
                                            decimalSeparator= '.'
                                            value={!isNullUndefined(objPolynomy.ponderador) ? objPolynomy.ponderador : 0}
                                            onChange={(e) => onChangeObjPolynomyString(e, 'ponderador')}
                                        />
                                        <CValidator isInValid={objIsValidPolynomyForm.isInValidPonderador} isInvalidText={!objIsValidPolynomyForm.isInValidPonderador ? "" : null} inValidText={t('data-lang-msg-required')} />
                                    </Col>
                                </Row>
                                <Row className='pt-1'>
                                    <Col xs={12} xl={6} className="mt-1">
                                        <div>
                                            <CLabel labelText={ t('data-lang-lbl-contractpartie-basedate') } />
                                        </div>
                                        <div>
                                            <JqxInput
                                                height={25}
                                                width={"100%"}
                                                value={objPolynomy.fechaBase}
                                                onChange={(e) => onChangeObjPolynomyTextInputString(e, 'fechaBase')}
                                            />
                                        <div>
                                        </div>
                                            <JqxInput
                                                height={25}
                                                width={"100%"}
                                                value={objPolynomy.valorBase}
                                                onChange={(e) => onChangeObjPolynomyTextInputString(e, 'valorBase')}
                                            />
                                        </div>
                                        <CValidator isInValid={objIsValidPolynomyForm.isInValidFechaBase} isInvalidText={!objIsValidPolynomyForm.isInValidFechaBase ? "" : null} inValidText={t('data-lang-msg-required')} />
                                        <div className='text-end'>
                                            {
                                                isNullUndefinedOrEmptyOrZero(objPolynomy.tipoPolinomioId) &&
                                                <DefaultButton disable={true} text={t('data-lang-btn-basevalue')} />
                                            }
                                            {
                                                !isNullUndefinedOrEmptyOrZero(objPolynomy.tipoPolinomioId) &&
                                                <DefaultButton onClick={onSelectBaseDateDialog} text={t('data-lang-btn-basevalue')} />
                                            }
                                        </div>
                                    </Col>
                                    <Col xs={12} xl={6} className="mt-1">
                                        <CLabel labelText={ t('data-lang-lbl-contractpartie-monthoffset') } />
                                        <Dropdown
                                            placeholder={t('data-lang-lbl-contractpartie-monthoffset')}
                                            options={contractFormPolynomyConfig.l_MESES_DESFASE !== null ? contractFormPolynomyConfig.l_MESES_DESFASE.map(item => { return  { key: item, text: item } }) : []}
                                            selectedKey={objPolynomy.mesesDesfase}
                                            onChange={handleSelectMonthDiff}
                                            checkable
                                            styles={ {title: { height: "27px" }} }
                                            className="mb-1"
                                        />
                                        <CValidator isInValid={objIsValidPolynomyForm.isInvalidMonthOffset} isInvalidText={!objIsValidPolynomyForm.isInvalidMonthOffset ? "" : null} inValidText={t('data-lang-msg-required')} />
                                    </Col>
                                </Row>
                                <Row className='pt-1'>
                                    <Col xs={12} xl={6} className="mt-1">
                                        <CLabel labelText={ t('data-lang-lbl-contractpartie-adjustmentmonthfrecuency') } />
                                        <JqxNumberInput
                                            inputMode="simple"
                                            width={80}
                                            height={25}
                                            digits={3}
                                            decimalDigits={0}
                                            min={0}
                                            max={999}    
                                            value={!isNullUndefined(objPolynomy.periodicidadMeses) ? objPolynomy.periodicidadMeses : 0}
                                            onChange={(e) => onChangeObjPolynomyString(e, 'periodicidadMeses')}
                                        />
                                        <CValidator isInValid={objIsValidPolynomyForm.isInValidPeriodicidadMeses} isInvalidText={!objIsValidPolynomyForm.isInValidPeriodicidadMeses ? "" : null} inValidText={t('data-lang-msg-required')} />
                                    </Col>
                                    <Col xs={12} xl={6} className="mt-1">
                                        <div>
                                            <CLabel labelText={ t('data-lang-lbl-contractpartie-firstmonthapply') } />
                                        </div>
                                        <div>
                                            <DatePicker
                                                selected={ objPolynomy.primerMesReajuste } 
                                                onChange={(date) => handlePolynomyDateChange(date, 'primerMesReajuste')}
                                                height={25}
                                                dateFormat="yyyy/MM"
                                                showMonthYearPicker
                                                showFullMonthYearPicker 
                                                placeholderText={ t('data-lang-lbl-contractpartie-firstmonthapply') } 
                                                className="form-control"
                                                customInput={ <CalendarCustomInput icon={<Icon styles={{root: { fontSize: "16px" }}} iconName='Calendar' />} /> }
                                            />
                                            <CValidator isInValid={objIsValidPolynomyForm.isInValidPrimerMesReajuste} isInvalidText={!objIsValidPolynomyForm.isInValidPrimerMesReajuste ? "" : null} inValidText={t('data-lang-msg-required')} />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='text-end'>
                                        <PrimaryButton onClick={ handleSavePolynomy }>{ t('data-lang-btn-save') }</PrimaryButton>
                                    </Col>
                                </Row>
                                <Row className='pt-2'>
                                    <Col>
                                        <Card className='border'>
                                            <Card.Body>
                                                <Row>
                                                {
                                                    objContractSubPartie.l_SUBPOLINOMIO && objContractSubPartie.l_SUBPOLINOMIO.map((polynomy, index) => (
                                                        <Col xl={6}>
                                                            <TablePolynomyItem
                                                                parentPolinomyType={enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE.SUBPARTIE}
                                                                parentId={objContractSubPartie.iteM_SUBPARTIDA.id}
                                                                tableItem={polynomy}
                                                                polynomyViewType={enum_CONTACTPARTIE_POLINOMY_FORM_VIEW.COMPLEX_EDIT}
                                                                addCardWidth={false}
                                                                handleDeletePolynomyClickAux={handleDeletePolynomyClick}
                                                                setTotalRestAdjustmentAmount={setTotalRestAdjustmentAmount}
                                                                l_POLINOMIO={objContractSubPartie.l_SUBPOLINOMIO}
                                                            />
                                                        </Col>
                                                    ))
                                                }
                                                {
                                                    totalRestAdjustmentAmount > 0 &&
                                                    <TablePolynomyItemNotAdjustment totalRestAdjustmentAmount={totalRestAdjustmentAmount} addCardWidth={false} />
                                                }
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        }
                    </fieldset>
                }
                {
                    isDialogOpen &&
                    <SidePanelBaseDateContractPartie
                        inputParam_IsDialogOpen={isDialogOpen}
                        inputParam_SetIsDialogOpen={setIsDialogOpen}
                        inputParam_SetSelectedBaseValue={handleSetPolynomyBaseDate}
                        inputParam_NemoIndicator={objPolynomy.tipoPolinomioTitle}
                        inputParam_StartDate={objContractPartie.mesInicioPartida}
                    />
                }
            </Panel>
        </div>
    );
};

SidePanelInsertEditContractSubPartie.propTypes = {
    elementId: PropTypes.number.isRequired,
};

export default SidePanelInsertEditContractSubPartie;